<template>
	<modal v-if="drop" :rootClass="'supply-drop-root'">
		<div slot="label" class="supply-drop-item" :title="drop.item.name">
			<ximg
				class="pixelated"
				:src="iconUrl"
				:ariaLabel="drop.item.name + ' supply drop item'"
				role="img"
			/>
			<div class="drop-qty" v-if="drop.count > 1">
				x{{ drop.count }}
			</div>
		</div>
		<div>
			<h3>{{ drop.item.name }}</h3>
			<span>{{ drop.item.description }}</span>
			<ximg
				class="pixelated"
				:src="iconUrl"
				:ariaLabel="drop.item.name + ' supply drop item'"
				role="img"
			/>
		</div>
	</modal>
</template>

<script>
export default {
	props: {
		drop: {
			type: Object,
		},
	},
	computed: {
		iconUrl () {
			return '/img/member/drops/' + this.drop.item.iconName + '.gif';
		},
	},
};
</script>
